import * as React from 'react';

function SvgAccountIcon(props) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12.104 4.242c0 2.306-1.915 4.182-4.268 4.182-2.352 0-4.267-1.876-4.267-4.182C3.57 1.936 5.484.06 7.836.06c2.353 0 4.268 1.876 4.268 4.182zM1.01 14.104c0-2.91 2.218-4.914 5.19-4.914h3.593c2.97 0 5.19 2.004 5.19 4.914v.313c0 1.521-2.497 1.521-5.388 1.521H6.397c-3.01 0-5.387 0-5.387-1.521v-.313z"
      />
    </svg>
  );
}

export default SvgAccountIcon;
